import Vue from 'vue'

HALSONResource = (data) ->
  data = data or {}
  if typeof data == 'string'
    data = JSON.parse(data)
  for attr of data
    if !(attr of this) and data.hasOwnProperty(attr)
      Vue.set @, attr, data[attr]
      # @[attr] = data[attr]
  if @_embedded and typeof @_embedded == 'object'
    _embedded = {}
    self = this
    Object.keys(@_embedded).forEach (key) ->
      if self._embedded.hasOwnProperty(key)
        _embedded[key] = [].concat(self._embedded[key]).map((embed) ->
          createHALSONResource embed
        )
      return
    Vue.set @, '_embedded', _embedded
  @_compact '_embedded'
  @_compact '_links'
  return

createHALSONResource = (data) ->
  if data and data.className == HALSONResource::className
    return data
  new HALSONResource(data)

HALSONResource::_compact = (name, key) ->
  target = @[name]
  if typeof target != 'object'
    return
  keys = if key then [ key ] else Object.keys(target)
  keys.forEach (k) ->
    items = target[k]
    if !Array.isArray(items)
      return
    if !items.length
      delete target[k]
    else if items.length == 1
      target[k] = items[0]
    return
  if !Object.keys(target).length
    return delete @[name]
  Vue.set @, name, target
  # @[name] = target
  return

HALSONResource::className = 'HALSONResource'

HALSONResource::_invert = (filterCallback) ->
  ->
    !filterCallback.apply(null, arguments)

HALSONResource::listLinkRels = ->
  if @_links then Object.keys(@_links) else []

HALSONResource::listEmbedRels = ->
  if @_embedded then Object.keys(@_embedded) else []

HALSONResource::getLinks = (rel, filterCallback, begin, end) ->
  if !@_links or !(rel of @_links)
    return []
  links = [].concat(@_links[rel])
  if filterCallback
    links = links.filter(filterCallback)
  links.slice begin or 0, end or links.length

HALSONResource::getLink = (rel, filterCallback, def) ->
  if typeof filterCallback != 'function'
    def = filterCallback
    filterCallback = null
  @getLinks(rel, filterCallback, 0, 1)[0] or def

HALSONResource::getEmbeds = (rel, filterCallback, begin, end) ->
  if !@_embedded or !(rel of @_embedded)
    return []
  items = [].concat(@_embedded[rel])
  if filterCallback
    items = items.filter(filterCallback)
  items.slice begin or 0, end or items.length

HALSONResource::getEmbed = (rel, filterCallback, def) ->
  if typeof filterCallback != 'function'
    def = filterCallback
    filterCallback = null
  @getEmbeds(rel, filterCallback, 0, 1)[0] or def

HALSONResource::getEmbedByRelAndUID = (rel, uid) ->
  @getEmbed rel, (embed) ->
    embed.uid == uid

HALSONResource::addLink = (rel, link) ->
  if typeof link == 'string'
    link = href: link
  if !@_links
    Vue.set @, '_links', {}
    # @_links = {}
  if !(rel of @_links)
    # single link
    Vue.set @_links, rel, link
    # @_links[rel] = link
  else
    # multiple links
    @_links[rel] = [].concat(@_links[rel])
    @_links[rel].push link
  this

HALSONResource::addEmbed = (rel, embed) ->
  @insertEmbed rel, -1, embed

HALSONResource::insertEmbed = (rel, index, embed) ->
  if !@_embedded
    Vue.set @, '_embedded', {}
  if !(rel of @_embedded)
    Vue.set @_embedded, rel, if Array.isArray(embed) then embed.map(createHALSONResource) else createHALSONResource(embed)
    return this
  items = [].concat(embed).map(createHALSONResource)
  Vue.set @_embedded, rel, [].concat(@_embedded[rel])
  if index < 0
    Array::push.apply @_embedded[rel], items
  else
    params = [
      index
      0
    ].concat(items)
    Array::splice.apply @_embedded[rel], params
  @_compact '_embedded', rel
  this

HALSONResource::removeLinks = (rel, filterCallback) ->
  if !@_links or !(rel of @_links)
    return
  if !filterCallback
    delete @_links[rel]
  else
    @_links[rel] = [].concat(@_links[rel]).filter(@_invert(filterCallback))
  @_compact '_links', rel
  this

HALSONResource::removeEmbeds = (rel, filterCallback) ->
  if !@_embedded or !(rel of @_embedded)
    return
  if !filterCallback
    return delete @_embedded[rel]
  @_embedded[rel] = [].concat(@_embedded[rel]).filter(@_invert(filterCallback))
  @_compact '_embedded', rel
  this

HALSONResource::removeEmbedByRelAndUID = (rel, uid) ->
  @removeEmbeds rel, (embed) ->
    embed.uid == uid
  this
  
createHALSONResource.Resource = HALSONResource

export default createHALSONResource



// WEBPACK FOOTER //
// ./src/services/HALSONResource.coffee